import { useMutation } from '@tanstack/react-query';

import { BusinessPlanFilesApi } from '../businessPlanFiles.api';

export const useBusinessPlanFileUpload = () => {
  return useMutation({
    mutationFn: BusinessPlanFilesApi.getS3UploadLink,
  });
};
